import { apiSlice } from "../api/apiSlice";

export const categoriesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    //get all  category
    getAllCategory: builder.query({
      query: () => ({
        url: `/category`,
        method: "GET",
      }),
    }),
    //get category by id
    getCategoryById: builder.query({
      query: (id) => ({
        url: `/category/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetAllCategoryQuery, useGetCategoryByIdQuery } =
  categoriesApi;
